// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "2ee179b923d4908dba0d23d012c21e7f" + ".css";
};